<template>
  <section class="bootcamp-overview">
    <div class="overview-container">
      <h3 class="section-subtitle">IN 30 DAYS IMPROVE DRASTICALLY</h3>
      <h2 class="section-title">Aiming, Movement, and Decision-Making</h2>
      <p class="section-description">
        This class is designed for students of all levels of experience.
      </p>
      <p class="section-description">
        No matter your level, you'll drastically improve your game-play by the
        end of the class.
      </p>
      <div class="overviews">
        <OverviewContent
          v-for="overview in BOOTCAMP_OVERVIEWS"
          :key="overview.title"
          :overview="overview"
        />
      </div>
    </div>
  </section>
</template>

<script>
import OverviewContent from "@/components/bootcamp/enroll/overview/OverviewContent.vue"
import { BOOTCAMP_OVERVIEWS } from "@/constants/bootcamp"

export default {
  components: {
    OverviewContent,
  },
  data: function () {
    return {
      BOOTCAMP_OVERVIEWS: BOOTCAMP_OVERVIEWS,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.bootcamp-overview {
  background: #fff;
  width: 100%;
  padding-bottom: 8rem;
  @include tablet-down {
    padding-bottom: 4rem;
  }

  .overview-container {
    border-radius: 2rem;
    border: 0.1rem solid #e2e2e2;
    max-width: 92rem;
    width: 95%;
    margin: auto;
    padding: 5.6rem 1.6rem 8.4rem;
    @include phone-down {
      border: none;
      padding-top: 0;
      padding-bottom: 0;
    }
    .section-description {
      margin-top: 0;
      &:first-of-type {
        margin-top: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/overview/TheBootcampOverview.vue